import { gql } from '@apollo/client';

export const GET_USER_PROFILE = gql`
  query GetUserProfile {
    me {
      id
      name
      email
      functie
      phone
      department
      nameForSend
      defaultRoute
      permissions
    }
  }
`;